//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';
import { jsonParse } from 'src_common/common/jsonParse';



export interface ParamsType {
    universe: string,
    body: {
        app_version: string,
        force_update: boolean,
        platform: string,
    },
}


const Response200IO = t.number;

export type Response200Type = number;

export const decodeResponse200 = (data: unknown): Response200Type => {
    const decodeResult = Response200IO.decode(data);
    if (isRight(decodeResult)) {
        return decodeResult.right;
    }
    throw Error('Response decoding error /website-cms/{universe}/mobile-app-version/update -> put -> 200');
};




const Response401IO = t.unknown;

export type Response401Type = unknown;

export const decodeResponse401 = (data: unknown): Response401Type => {
    const decodeResult = Response401IO.decode(data);
    if (isRight(decodeResult)) {
        return decodeResult.right;
    }
    throw Error('Response decoding error /website-cms/{universe}/mobile-app-version/update -> put -> 401');
};




const Response404IO = t.unknown;

export type Response404Type = unknown;

export const decodeResponse404 = (data: unknown): Response404Type => {
    const decodeResult = Response404IO.decode(data);
    if (isRight(decodeResult)) {
        return decodeResult.right;
    }
    throw Error('Response decoding error /website-cms/{universe}/mobile-app-version/update -> put -> 404');
};




const Response500IO = t.unknown;

export type Response500Type = unknown;

export const decodeResponse500 = (data: unknown): Response500Type => {
    const decodeResult = Response500IO.decode(data);
    if (isRight(decodeResult)) {
        return decodeResult.right;
    }
    throw Error('Response decoding error /website-cms/{universe}/mobile-app-version/update -> put -> 500');
};






export const openapi_mobile_app_version_update_putMobileAppUpdateVersion = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType): Promise<FetchGeneralRawResponseType> => {
    const url = `${api_url}/website-cms/${params.universe}/mobile-app-version/update`;
    const method = 'PUT';
    const paramsFetch = {
        url,
        body: params.body,
        backendToken,
        timeout: api_timeout,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiMobileAppVersionUpdatePutMobileAppUpdateVersionParamsType = ParamsType;

export type OpenapiMobileAppVersionUpdatePutMobileAppUpdateVersionResponseType = {
    status: 200,
    body: Response200Type,
} | {
    status: 401,
    body: Response401Type,
} | {
    status: 404,
    body: Response404Type,
} | {
    status: 500,
    body: Response500Type,
};

export type OpenapiMobileAppVersionUpdatePutMobileAppUpdateVersionResponse200Type = Response200Type;

export const openapiMobileAppVersionUpdatePutMobileAppUpdateVersionRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType): Promise<OpenapiMobileAppVersionUpdatePutMobileAppUpdateVersionResponseType> => {
    const response = await openapi_mobile_app_version_update_putMobileAppUpdateVersion(api_url, api_timeout, backendToken, params);
    const { status, body } = response;
    const bodyParsed = jsonParse(body);

    if (bodyParsed.type === 'text') {
        throw Error(`Http status ${status} - json was expected`);
    }

    
    if (status === 200) {
        return {
            status: 200,
            body: decodeResponse200(bodyParsed.json)
        };
    }


    if (status === 401) {
        return {
            status: 401,
            body: decodeResponse401(bodyParsed.json)
        };
    }


    if (status === 404) {
        return {
            status: 404,
            body: decodeResponse404(bodyParsed.json)
        };
    }


    if (status === 500) {
        return {
            status: 500,
            body: decodeResponse500(bodyParsed.json)
        };
    }

    throw new Error(`openapiMobileAppVersionUpdatePutMobileAppUpdateVersionRequest - unhandled response ${response.status}`);
};

